import { FormControl, FormHelperText } from '@mui/material';
import { COUNTRIES_FOR_PHONE_NUMBER } from 'constants/CommonConstants';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import styled from 'styled-components';
import { FormInputProps } from './InputInterface';
import DabaduTooltip from 'sharedComponents/toolTip';

const DabaduFormControl = styled(FormControl)`
  &.MuiFormControl-root {
    width: 100%;
    .form-control,
    .flag-dropdown {
      border-width: 1px;
      border-color: ${(props) => props.theme.colors.inputBorder};
      background-color: transparent;
    }
    .react-tel-input {
      .selected-flag {
        width: 50px;
        padding-left: 15px;
      }
    }
    .form-control {
      height: auto;
      padding: 18px 20px 18px 60px;
      width: 100%;
      border-radius: 4px;
      font-weight: 300;
      font-size: 1rem;
      letter-spacing: 0;
      line-height: 1.4;
      font-family: ${(props) => props.theme.fonts.primary};
      color: ${(props) => props.theme.colors.textColor};

      @media (max-width: 1650px) {
        padding: 12px 14px 12px 54px;
      }
    }
  }
  & .MuiFormHelperText-root {
    margin-left: 0;
  }
`;

export const CommonPhoneInput = ({
  name,
  control,
  label,
  placeholder,
  rules,
  hint,
  triggerValidationForField,
}: FormInputProps) => {
  return (
    <>
      {label && (
        <label className='control-label'>
          {label}
          {hint && (
            <DabaduTooltip title={hint} placement='top-end' className='tooltip-wrapper'>
              <span>
                <span className='tooltip-wrapper__text'>i</span>
              </span>
            </DabaduTooltip>
          )}
        </label>
      )}
      <DabaduFormControl component='fieldset' required={Boolean(rules)} error={Boolean(rules)}>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <>
              <PhoneInput
                placeholder={placeholder}
                country={COUNTRIES_FOR_PHONE_NUMBER[0]}
                onlyCountries={COUNTRIES_FOR_PHONE_NUMBER}
                countryCodeEditable={false}
                value={value}
                // onChange={onChange}
                onChange={(val) => {
                  // clearErrors(name);

                  onChange(val);
                  triggerValidationForField(name);
                }}
              />

              {Boolean(error?.message) && <FormHelperText>{error?.message}</FormHelperText>}
            </>
          )}
        />
      </DabaduFormControl>
    </>
  );
};
